import { render, staticRenderFns } from "./DialogFormAttachmentEdit.vue?vue&type=template&id=f1751a8c"
import script from "./DialogFormAttachmentEdit.vue?vue&type=script&lang=js"
export * from "./DialogFormAttachmentEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports